import React, { Component } from 'react';
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {
    TableRow,
    TableCell
} from "@amzn/meridian/table";
import CommonFilters from '../../commons/CommonFilters';
import { ageingRowMapping_ForwardLeg, ageingRowMapping_ReverseLeg, ageingRowMapping_ForwardLeg_XptView, Columns, ageingRowMapping_ForwardLeg_DsView} from '../../commons/dataStore/PackageResultsData'
import { processConditionalMetrics } from '../../util/MetricUtils';
import { FiltersStateContext } from '../../commons/context/FiltersStateContext';
import {handlePackageStateToGenericTextMapping} from "../../commons/CommonUtils";
import Link from "@amzn/meridian/link";
import Loader from "@amzn/meridian/loader";
import {PackageTypes_Reverse} from "../../commons/dataStore/FilterDataStore"
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small"
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small"
import Icon from "@amzn/meridian/icon"
import {FormattedMessage} from "react-intl";
import {  withScrubInterface } from '../scrub/ScrubInterface';
import { ScrubHome } from '../scrub/ScrubHome';
import RefreshTimer from "../../commons/RefreshTimer";
import {PAGE_HEADERS} from "../../commons/constants/CommonConstants";
import PageHeader from "../../commons/PageHeader";

export default class AgeingDataUI extends Component {

    static contextType = FiltersStateContext;
    constructor(props) {

        super(props)
        this.state = {
          expandedSections : [],
          view : "AGEING_VIEW",
          data : props.data
        }

        this.getMetricFromPackageToColumnMap = (section, column, direction) => {

            var sectionData = this.props.data.filter(status => status.packageStatus === section);
            var timeToMetricDataMapForSection = sectionData && sectionData.length > 0 ? sectionData : [];
            var columnToMetricEntity = direction ?  (timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null) ? 
            timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null).columnToViewDataMap : []) :
                (timeToMetricDataMapForSection.length > 0 ? timeToMetricDataMapForSection[0].columnToViewDataMap : []) 
            if (column === "_MIN") {  
                column = JSON.stringify(columnToMetricEntity).match(/[0-9]*_MIN/g);
            }
            return columnToMetricEntity[column] ? columnToMetricEntity[column].value : 0
        }

        this.backendStateToMetricMapping = (subsection) => {

            return subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : subsection;
        }
        
        /**
        * This calculates total count for section metric
        */
       this.getSectionMetricFromSubsectionData = (section, column) => {

        var totalCount = 0;
        section.Subsections.length > 0 ?
        section.Subsections.map(subsection =>  subsection.Section ?
                subsection.Subsections.map(s => totalCount+= Number(this.getMetricFromPackageToColumnMap((s.localeCompare(subsection.Section) !== 0 ? s.split(" (", 1)[0]: ""), column,  s.split(" (", 2)[1] ? s.split(" (", 2)[1].split(")" , 1)[0] : ""))) :
        (totalCount += Number(this.getMetricFromPackageToColumnMap(subsection.localeCompare(section.Section) !== 0 ? subsection.split(" (", 1)[0]: "", column,  subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")))) :
        //In case when there is no subsection
        totalCount += Number(this.getMetricFromPackageToColumnMap(section.Section, column))
        return totalCount

    }
    
        this.toggleRow = section => {

            if (this.state.expandedSections.indexOf(section) !== -1) {
                this.setState({
                expandedSections : this.state.expandedSections.filter(expandedSection => expandedSection !== section)}
                )
            } 
            else  {
                this.setState({
                expandedSections : this.state.expandedSections.concat(section)
                })
            } 
        }

        this.isSectionExpanded = section => {
            return this.state.expandedSections.indexOf(section) !== -1;
        }

        this.constructState = (section, timeColumn, isTotal) => {

            let subsections = Array.isArray(section)  ? [].concat.apply([], section): section;

            var values = {
                cycles : this.context.selectedFilterValues.cycles,
                startPDD : this.context.selectedFilterValues.startPDD,
                endPDD : this.context.selectedFilterValues.endPDD,
                packageTypes  : this.context.selectedFilterValues.leg === "Reverse" ? this.context.selectedFilterValues.packageTypes_Reverse ? [].concat.apply([], 
                    this.context.selectedFilterValues.packageTypes_Reverse.map(packageType => {return PackageTypes_Reverse[packageType]})) : [] :
                ["Core Volume"],
                packageStatuses : Array.isArray(subsections) ? subsections : [subsections],
                dwellEndTime : timeColumn,
                dwellStartTime : timeColumn.match(/[0-9]*_MIN/g) ? (isTotal ? "30_DAY" : "1_DAY") : undefined,
                leg : this.context.selectedFilterValues.leg,
                page: "AGEING"
            }

            //Redirect to search path
            var path = window.location.href;
            var searchPath = path[path.length - 1] === "/" ? path + "packageSearch/" : path + "/packageSearch/";
            return searchPath + JSON.stringify(values).replaceAll('/','%2f');
        }

        this.AgeingDataRowMapping = (selectedFilterValueLeg, viewType) => {
            if (selectedFilterValueLeg === "Reverse") {
                return ageingRowMapping_ReverseLeg
            } else {
                if (viewType === "XPT_VIEW") {
                    return ageingRowMapping_ForwardLeg_XptView;
                } else if (viewType === "DS_VIEW") {
                    return ageingRowMapping_ForwardLeg_DsView;
                }
                return ageingRowMapping_ForwardLeg;
            }
        }

    }
 
    render() {

        const formattedIdPrefix = "commons.";
        const viewType = this.props.viewTypeForStation;
        let rowMapping = this.AgeingDataRowMapping(this.context.selectedFilterValues.leg, viewType);
        // Process row mapping based on conditional metrics
        rowMapping = processConditionalMetrics(this.props.data, rowMapping);

        const view = this.state.view.concat(this.context.selectedFilterValues.leg === "Reverse"  ? "_REVERSE" : "_FORWARD");
        const isRtsAgeingGenericLabelsEnabledForReverse = this.props.isRtsAgeingGenericLabelsEnabled && this.context.selectedFilterValues.leg === "Reverse";

        return (
        <Column spacing="medium" spacingInset={this.props.spacingInset_shorthand2}>
            <PageHeader {...PAGE_HEADERS.AGEING}/>
            <CommonFilters view={view} />
            <RefreshTimer deps={[this.props.data]}/>
            {withScrubInterface(ScrubHome)()}
            <Row widths="100%">
                <div style={{ overflowX: "auto", width: "100%" }}>
                    <Table spacing="small"
                           headerRows={1}
                           headerColumns={1}
                           stickyHeaderColumn={true}
                           fixHeaderRows={true}
                           stickyHeaderRow={true}>
                        <TableRow>
                            <TableCell alignmentHorizontal = "left">
                               <Text type="h100">
                                   <FormattedMessage id="aging.status" defaultMessage="Status"/>
                               </Text>
                            </TableCell>
                            <TableCell alignmentHorizontal = "right"><Text type="h100">&lt;
                                <FormattedMessage id="aging.one_day" defaultMessage="1 day"/>
                            </Text></TableCell>
                            <TableCell alignmentHorizontal = "right"><Text type="h100">
                                <FormattedMessage id="aging.one_day" defaultMessage="1 day"/>
                            </Text></TableCell>
                            <TableCell alignmentHorizontal = "right"><Text type="h100">
                                <FormattedMessage id="aging.two_day" defaultMessage="2 days"/>
                            </Text></TableCell>
                            <TableCell alignmentHorizontal = "right"><Text type="h100">
                                <FormattedMessage id="aging.three_day" defaultMessage="3 days"/>
                            </Text></TableCell>
                            <TableCell alignmentHorizontal = "right"><Text type="h100">
                                <FormattedMessage id="aging.four_plus_day" defaultMessage="4+ days"/>
                            </Text></TableCell>
                            <TableCell alignmentHorizontal = "right"><Text type="h100">
                                <FormattedMessage id="aging.total" defaultMessage="Total"/>
                            </Text></TableCell>
                        </TableRow>
                        { this.props.isLoading ? <TableRow><TableCell columnSpan = {7} alignmentHorizontal = "center"><Loader/></TableCell></TableRow>:
                         this.props.data && this.props.data.length > 0 && rowMapping.map(section => (

                        <TableRow key={section.Section} open={this.isSectionExpanded(section.Section)} onClick={() => this.toggleRow(section.Section)}>
                            <TableCell  alignmentHorizontal = "left"><FormattedMessage id ={formattedIdPrefix.concat(section.Section.split(' ').join('_').toLocaleLowerCase())} defaultMessage={section.Section}/></TableCell>
                            {
                                Columns.map( col =>
                                <TableCell alignmentHorizontal = "right">
                                    {
                                        this.getSectionMetricFromSubsectionData(section, col) !== 0
                                            ? <Link href = {this.constructState(section.Subsections.length > 0
                                                        ? section.Subsections.map( subsection => {
                                                            return subsection.Section
                                                                ? subsection.Subsections.filter(sub=> sub !== subsection.Section)
                                                                : subsection})
                                                        : section.Section,
                                            col,
                                            col === "TOTAL" ? true : false)}
                                                        type="secondary">
                                                {this.getSectionMetricFromSubsectionData(section, col)}
                                              </Link>
                                            : this.getSectionMetricFromSubsectionData(section, col)
                                    }
                            </TableCell> )}

                            { section.Subsections.map(subsection => subsection.Section ? subsection.Subsections.map(sub=>

                                       sub === subsection.Section ?
                                      <TableRow key={subsection.Section} open={this.isSectionExpanded(subsection.Section)} onClick={() => this.toggleRow(subsection.Section)}>
                                          <TableCell alignmentHorizontal = "left">
                                             <Row spacingInset="none none none medium" wrap="down">
                                                    <Icon tokens={this.isSectionExpanded(subsection.Section) ? chevronDownSmallTokens : chevronRightSmallTokens}/>
                                                    <FormattedMessage id ={formattedIdPrefix.concat(subsection.Section.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection.Section}/></Row>
                                        </TableCell>
                                    { Columns.map( col => <TableCell alignmentHorizontal = "right">
                                    {this.getSectionMetricFromSubsectionData(subsection , col).toString() !== "0" ? <Link href = {this.constructState(subsection.Subsections.length > 0 ? subsection.Subsections.filter( s => s !== subsection.Section) :
                                            subsection.Section, col, col === "TOTAL" ? true : false)} type="secondary">

                                             {this.getSectionMetricFromSubsectionData(subsection , col)}
                                         </Link> :
                                         this.getSectionMetricFromSubsectionData(subsection , col)}
                                        </TableCell> )} </TableRow> :
                                     this.isSectionExpanded(subsection.Section) ? <TableRow>
                                     <TableCell  alignmentHorizontal = "left"><Row spacingInset="none none none xlarge"><FormattedMessage id ={formattedIdPrefix.concat(this.backendStateToMetricMapping(sub).toLocaleLowerCase().split(' ').join('_'))} defaultMessage={sub}/></Row></TableCell>
                                    { Columns.map( col =>

                                    <TableCell alignmentHorizontal = "right">
                                      {this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ? <Link href = {this.constructState(sub, col, col === "TOTAL" ? true : false)} type="secondary">
                                         {this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                    </Link> :
                                         this.getMetricFromPackageToColumnMap(sub.split(" (", 1)[0], col, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                    </TableCell> )} </TableRow>

                                : null ):

                                <TableRow>
                                    <TableCell alignmentHorizontal = "left" ><Row spacingInset="none none none medium" wrap="down">
                                    <FormattedMessage id ={formattedIdPrefix.concat(handlePackageStateToGenericTextMapping("AGEING",
                                        section.Section, subsection, viewType, isRtsAgeingGenericLabelsEnabledForReverse)
                                        .toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection}/></Row></TableCell>
                                { Columns.map(col =>

                                <TableCell alignmentHorizontal = "right">
                                    {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, (subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")).toString() !== "0" ? (
                                    <Link href = {this.constructState(subsection, col, col === "TOTAL" ? true : false)} type="secondary">

                                        {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                    </Link> ) : this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                </TableCell>)}
                            </TableRow>)}
                            </TableRow>))}
                    </Table>
                </div>
        </Row>
    </Column>
    )
  } 
}
                    


// WEBPACK FOOTER //
// ./src/components/ageing/AgeingDataUI.js